export interface Credentials {
    id: number;
    value: string;
    keyvalue: string;
    key: string;
    name: string;
    created_at: string;
    updated_at: string;
    description: string;
}
